import { stringifyQs } from "@dashboard/utils/urls";

export const passwordResetPath = "/reset-password/";
export const passwordResetUrl = passwordResetPath;

export const passwordResetSuccessPath = "/reset-password/success/";
export const passwordResetSuccessUrl = passwordResetSuccessPath;

export const newPasswordPath = "/new-password/";

export const loginCallbackPath = "/login/callback/";

export interface NewPasswordUrlQueryParams {
  email: string;
  token: string;
}
export const newPasswordUrl = (params?: NewPasswordUrlQueryParams) =>
  newPasswordPath + "?" + stringifyQs(params);

interface LoginOpenidconnectUrlQueryParams {
  code: string;
  state: string;
  /** The provider's refusal, when it sends one back instead of a code (RFC 6749 4.1.2.1). */
  error?: string;
  error_description?: string;
}
export type LoginUrlQueryParams = LoginOpenidconnectUrlQueryParams;
